import { defineComponent, toRefs, computed, openBlock, createElementBlock, createElementVNode, normalizeStyle, createCommentVNode, renderSlot } from 'vue';
import { DEFAULT_GUTTER } from './config2.js';
import { getFormattedGutterValue } from './utils2.js';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "TDescription",
  props: {
    column: {
      type: Number,
      default: 12
    },
    gutter: {
      type: [Number, Array],
      default: () => DEFAULT_GUTTER,
      validator: (val) => {
        if (typeof val === "number") {
          return true;
        } else if (val instanceof Array && val.length === 2 && val.every((item) => typeof item === "number")) {
          return true;
        }
        return false;
      }
    },
    direction: {
      type: String,
      default: "horizontal"
    }
  },
  setup(props) {
    const { gutter } = toRefs(props);
    const computedGutter = computed(() => getFormattedGutterValue(gutter.value));
    return {
      computedGutter
    };
  }
});
const _hoisted_1 = { class: "t-description" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      class: "t-description__content",
      style: normalizeStyle({
        margin: `-${_ctx.computedGutter[0]}px -${_ctx.computedGutter[1]}px`
      })
    }, [
      createCommentVNode(" @slot \u63D2\u69FD\u4E2D\u5FC5\u987B\u4F20\u5165 TDescriptionItem \u7EC4\u4EF6 "),
      renderSlot(_ctx.$slots, "default")
    ], 4)
  ]);
}
var Description = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/description/src/description.vue"]]);

export { Description as default };
//# sourceMappingURL=description.vue2.js.map
